import { render, staticRenderFns } from "./TooltipRoot.vue?vue&type=template&id=bf4febf0"
import script from "./TooltipRoot.vue?vue&type=script&lang=ts"
export * from "./TooltipRoot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports